import { Controller } from "@hotwired/stimulus"

// Client-side column sorting for small hand-rolled tables (the Reddit panel's
// subreddit/keyword scoreboards — dozens of rows, no pagination). Click a header to
// sort; click again to reverse. Cells may carry an explicit data-sort-value
// (numbers, epochs); otherwise the cell text is compared, numerically when both
// sides parse as numbers.
export default class extends Controller {
  sort(event) {
    const th = event.currentTarget
    const headers = Array.from(th.parentNode.children)
    const index = headers.indexOf(th)
    const tbody = this.element.querySelector("tbody")
    const desc = th.dataset.sorted !== "desc" // first click sorts DESC (biggest counts first)

    headers.forEach((h) => {
      delete h.dataset.sorted
      h.textContent = h.textContent.replace(/ [↑↓]$/, "")
    })
    th.dataset.sorted = desc ? "desc" : "asc"
    th.textContent += desc ? " ↓" : " ↑"

    const value = (row) => {
      const cell = row.children[index]
      return cell?.dataset.sortValue ?? cell?.textContent.trim() ?? ""
    }
    const rows = Array.from(tbody.querySelectorAll("tr"))
    rows.sort((a, b) => {
      const [va, vb] = [value(a), value(b)]
      const [na, nb] = [parseFloat(va), parseFloat(vb)]
      const cmp = (!isNaN(na) && !isNaN(nb)) ? na - nb : va.localeCompare(vb, undefined, { sensitivity: "base" })
      return desc ? -cmp : cmp
    })
    rows.forEach((row) => tbody.appendChild(row))
  }
}
